import {inject, Injectable} from '@angular/core';
import {HttpClient, HttpParams} from '@angular/common/http';
import {Observable} from 'rxjs';
import {ThirdPartyLicenseManagement} from './third-party-license-management.service';
import {Page} from '@uofu-uss/angular-util';

@Injectable({
  providedIn: 'root',
})
export class ThirdPartyLicenseManagementDataService {

  public static readonly baseUrl = '/api/third-party-license-management';

  private readonly http = inject(HttpClient);

  createTplm(tplm: ThirdPartyLicenseManagement): Observable<ThirdPartyLicenseManagement> {
    return this.http.put<ThirdPartyLicenseManagement>(
      `${ThirdPartyLicenseManagementDataService.baseUrl}/`,
      tplm,
    );
  }

  fetchTplm(id: number): Observable<ThirdPartyLicenseManagement> {
    return this.http.get<ThirdPartyLicenseManagement>(
      `${ThirdPartyLicenseManagementDataService.baseUrl}/${id}`,
    );
  }

  searchTplm(thirdPartyLicenseOfferingId: number, emplid: string, page: number, size: number):
    Observable<Page<ThirdPartyLicenseManagement>> {
    const params = new HttpParams().appendAll({thirdPartyLicenseOfferingId, emplid, page, size});
    return this.http.get<Page<ThirdPartyLicenseManagement>>(
      `${ThirdPartyLicenseManagementDataService.baseUrl}/`, {params});
  }
}
